import styled from 'styled-components'
import PropTypes from 'prop-types'
import { themeGet } from 'styled-system'
import { Heading } from 'grommet'
import {
  toNoBreakContentArray,
  toContentArray,
} from '../../utils/componentHelpers'

const HeaderTwo = styled(Heading).attrs(({ dataTestId, children }) => {
  const contentArray = toContentArray(children)
  const noBreakContentArray = toNoBreakContentArray(contentArray)
  return {
    a11yTitle: 'Header',
    'data-testid': dataTestId,
    level: 2,
    responsive: false,
    children: noBreakContentArray,
  }
})`
  color: ${themeGet('colors.heading.level.2')};
  letter-spacing: 0.03125rem;
  max-width: none;

  ${themeGet('breakpoints.tablet')} {
    font-size: ${themeGet('heading.level.2.tablet.size')};
    line-height: ${themeGet(`heading.level.2.tablet.height`)};
  }

  ${themeGet('breakpoints.mobile')} {
    font-size: ${themeGet(`heading.level.2.mobile.size`)};
    line-height: ${themeGet(`heading.level.2.mobile.height`)};
  }
`

HeaderTwo.propTypes = {
  children: PropTypes.node.isRequired,
  dataTestId: PropTypes.string.isRequired,
  textAlign: PropTypes.string,
}

HeaderTwo.defaultProps = {
  textAlign: 'start',
}

HeaderTwo.displayName = 'HeaderTwo'

export default HeaderTwo
